import toCamelCase from '@/lib/helpers/to-camel-case';

const idParser = (name) => {
  const lowerCaseName = name[0].toLowerCase() + name.slice(1);
  const nameWithBars = lowerCaseName.split(' ').join('-');
  const nameToCamel = toCamelCase(nameWithBars);

  return nameToCamel;
};

export default idParser;
